/** @jsxImportSource @emotion/react */
import React, { useContext, useState } from 'react';
import { initPrescription, OrderContext } from '../../common/providers/ContextProvider';
import { ThemeContext } from '../../config/theme';
import { PrescriptionChoice, prescriptionData } from '../../utils/types';
import PrescriptionForm from './PrescriptionForm';
import themedStyles from './PrescriptionUpload.css';

export default function PrescriptionUpload() {
  const { prescription, setPrescription } = useContext(OrderContext);
  const [showPrescriptionForm, setShowPrescriptionForm] = useState(false);

  const togglePrescriptionForm = () => {
    setShowPrescriptionForm((prevState) => !prevState);
    return setPrescription(initPrescription);
  };

  const handlePrescriptionInput = (data: prescriptionData) => {
    setPrescription({ title: PrescriptionChoice.Form, data });
  };

  const handlePrescriptionLater = (
    prescriptionChoice: PrescriptionChoice.Later | PrescriptionChoice.Account
  ) => {
    setShowPrescriptionForm(false);
    if (prescription.title === prescriptionChoice) {
      return setPrescription(initPrescription);
    }
    setPrescription({ title: prescriptionChoice, data: '' });
  };

  const styling = themedStyles(useContext(ThemeContext));
  return (
    <div>
      <h1>Legg til styrke</h1>
      <button css={styling.radioInput} onClick={togglePrescriptionForm}>
        <div css={[styling.selectedIndicator, showPrescriptionForm && styling.selected]} />
        <p>Fyll inn brilleseddel</p>
      </button>
      {showPrescriptionForm && (
        <PrescriptionForm
          onSubmitForm={handlePrescriptionInput}
          submittedPrescriptionData={prescription.data}
        />
      )}
      <button
        css={styling.radioInput}
        onClick={() => handlePrescriptionLater(PrescriptionChoice.Account)}>
        <div
          css={[
            styling.selectedIndicator,
            prescription.title === PrescriptionChoice.Account && styling.selected,
          ]}
        />
        <p>Bruk brilleseddel fra kundekonto</p>
      </button>
      <button
        css={styling.radioInput}
        onClick={() => handlePrescriptionLater(PrescriptionChoice.Later)}>
        <div
          css={[
            styling.selectedIndicator,
            prescription.title === PrescriptionChoice.Later && styling.selected,
          ]}
        />
        <div className="flex flex-column items-start">
          <p className="mb0">Send brilleseddel på epost til</p>
          <p className="mt0">hei@okkult.com</p>
        </div>
      </button>
    </div>
  );
}
